import React, { useEffect, useState } from 'react';
import { getDefaultCurrencyForCountry } from '../utils/countryUtils';
export function CurrencySelector({
  value,
  onChange,
  countryCode,
  locale
}) {
  const [currencies, setCurrencies] = useState([{
    code: 'AUD',
    name: 'Australian Dollar'
  }, {
    code: 'USD',
    name: 'US Dollar'
  }, {
    code: 'EUR',
    name: 'Euro'
  }, {
    code: 'GBP',
    name: 'British Pound'
  }, {
    code: 'JPY',
    name: 'Japanese Yen'
  }, {
    code: 'CAD',
    name: 'Canadian Dollar'
  }, {
    code: 'CHF',
    name: 'Swiss Franc'
  }, {
    code: 'CNY',
    name: 'Chinese Yuan'
  }, {
    code: 'INR',
    name: 'Indian Rupee'
  }, {
    code: 'BRL',
    name: 'Brazilian Real'
  }, {
    code: 'RUB',
    name: 'Russian Ruble'
  }, {
    code: 'ZAR',
    name: 'South African Rand'
  }, {
    code: 'MXN',
    name: 'Mexican Peso'
  }, {
    code: 'SGD',
    name: 'Singapore Dollar'
  }, {
    code: 'AED',
    name: 'UAE Dirham'
  }
  // Add more currencies as needed
  ]);
  // When component mounts or country changes, update currency
  useEffect(() => {
    if (!value) {
      // Always default to AUD regardless of country
      onChange('AUD');
    }
  }, [countryCode, value, onChange]);
  return <select value={value || 'AUD'} onChange={e => onChange(e.target.value)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-17426">
      <option value="" data-id="element-17427">Select a currency</option>
      {currencies.map(currency => <option key={currency.code} value={currency.code} data-id="element-17428">
          {currency.code} - {currency.name}
        </option>)}
    </select>;
}